let BaseUrl = {};
switch (process.env.NODE_ENV) {
  case "development":
    BaseUrl = {
      // dev: "http://192.168.2.161:8000",
      dev: "https://conference-saas-api.techbrj.com",
    };
    break;
  case "production":
    BaseUrl = {
      dev: "https://conference-saas-api.techbrj.com",
    };
    break;
  default:
    BaseUrl = {
      dev: "https://conference-saas-api.techbrj.com",
    };
    break;
}

export default BaseUrl;
